import { Dialog, Modal, Toast } from "antd-mobile";

import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import {
  differenceBetweenTransferDates,
  groupByMultiple,
  lowerCase,
  momentDate,
  queryParam,
  SkeltonLoop,
  upperCase,
  useQuery,
  yearByBatch,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";

import ButtonScreen from "./buttonScreen";
import SwipeScreen from "./swipeScreen";
import { List, Skeleton, Select } from "antd";
import { _CheckAttEntered, _ListLessonPlans } from "../../models/lessonPlans";

const AttendanceEntry = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [longAbsentee, setLongAbsentee] = useState([]);

  const [markedData, setMarkedData] = useState([]);
  const [markedOd, setMarkedOd] = useState([]);

  const [markedStudents, setMarkedStudents] = useState([]);
  const [workDone, setWorkDone] = useState(null);
  const workDoneRef = useRef(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [allowAttendance, setAllowAttendance] = useState(false);
  const [markedDatasource, setMarkedDataSource] = useState([]);
  const [lessonPlanList, setLessonPlanList] = useState([]);
  const [attEnteredData, setAttEnteredData] = useState([]);
  const [selectedLessonPlan, setSelectedLessonPlan] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(null);
  //const [screenType, setScreenType] = useState("swipe");
  let searchParams = queryParam(useQuery());
  const stateField = (fieldName) => {
    return searchParams?.[fieldName] || "";
  };
  const getAttendanceDate = () => {
    let m = stateField("attendance_date");
    if (m && m.length > 7) return momentDate(m, "YYYY-MM-DD");

    let x = context.getStorage("mob_attendance_date");
    return x && x != null ? x : momentDate(new Date(), "YYYY-MM-DD");
  };
  const [attendaceDate, setAttendaceDate] = useState(getAttendanceDate());

  useEffect(() => {
    console.log(searchParams);
    checkAttTaken();
  }, []);

  const checkAttTaken = () => {
    setLoader(true);
    setLessonPlanList([]);
    _CheckAttEntered({
      course_uuid: stateField("course_uuid"),
      college_uuid: stateField("college_uuid"),
      batch: stateField("batch"),
      semester: stateField("semester"),
      section: stateField("section"),
      hour_value: stateField("hour_value"),
      attendance_date: attendaceDate,
    }).then((res) => {
      if (res.status == "1") {
        setAttEnteredData(res.data);
        setSelectedTopic(stateField("hour_topic"));
        if (
          res.data &&
          res.data.length > 0 &&
          context.user.uuid != res.data[0].marked_teacher_uuid
        ) {
          Toast.show({
            content: `Attendance Already marked by ${res.data[0].marked_by}`,
          });
          return;
        } else if (stateField("course_uuid") != undefined) {
          loadAllDatas();
        }
      }
    });
    setLoader(false);
  };

  let allowOd =
    context.settingValue(
      "attendance_allow_od_by_staff",
      context.user.college_uuid,
    ) == "1";
  let screenType = context.settingValue(
    "mob_staff_att_screen_type",
    context.user.college_uuid,
  );
  //console.log(context);

  /*   useEffect(() => {
    setSelectedTopic(stateField("hour_topic"));
    if (attEnteredData && attEnteredData.length > 0) {
      Toast.show({
        content: `Attendance Already marked by ${attEnteredData[0].marked_by}`,
      });
      return;
    } else if (
      stateField("course_uuid") != undefined &&
      attEnteredData.length == 0
    ) {
      loadAllDatas();
    }
  }, []); */

  const loadAllDatas = () => {
    loadLongAbsenteeData();
    loadData();
    loadMarkedAttendance();
    loadLessonPlan();
  };

  const loadLessonPlan = () => {
    setLoader(true);
    setLessonPlanList([]);
    _ListLessonPlans({
      course_uuid: stateField("course_uuid"),
      college_uuid: stateField("college_uuid"),
      batch: stateField("batch"),
      semester: stateField("semester"),
      subject: stateField("subject"),
    }).then((res) => {
      if (res.status == "1") {
        let m = groupByMultiple(res.data, function (obj) {
          return [obj.unit_id];
        });

        setLessonPlanList(res.data);
      }
    });
    setLoader(false);
  };

  useEffect(() => {
    if (dataList.length > 0) mergeData();
    else setLoader(false);
  }, [dataList, markedData, markedOd]);

  const loadMarkedAttendance = () => {
    context.setLoader(true);
    const form = new FormData();
    form.append("attendance_date", attendaceDate);
    //form.append("day_value", stateField("day_value"));
    form.append("hour_value", stateField("hour_value"));
    form.append("teacher", stateField("teacher"));
    form.append("subject", stateField("subject"));
    if (stateField("subject_part") != "4")
      form.append("course_uuid", stateField("course_uuid"));
    form.append("college_uuid", stateField("college_uuid"));
    form.append("college_year", stateField("college_year"));
    form.append("batch", stateField("batch"));
    form.append("semester", stateField("semester"));
    form.append("section", stateField("section"));
    form.append("marked_teacher_uuid", stateField("marked_teacher_uuid"));
    form.append("marked_subject", stateField("marked_subject"));
    //form.append("entry_type", stateField("entry_type"));

    const hourValue = stateField("hour_value");
    const dynamicEntryType = `hour_${hourValue}_entry_type`;
    form.append(`hour_${hourValue}_entry_type`, stateField("entry_type"));

    axios.post(ServiceUrl.MOB.LIST_STUDENTS_ATTENDANCE, form).then((res) => {
      if (res["data"].status == "1") {
        if (res["data"].work_done) {
          let w = res["data"].work_done;
          if (w && w.work_done) setWorkDone(w.work_done);
        }
        setMarkedDataSource(res["data"].data);
        setMarkedData(res["data"].data);
        console.log("res.data", res["data"].data);
        context.setLoader(false);
      }
      //context.setLoader(false);
    });
  };

  const loadData = () => {
    context.setLoader(true);
    const form = new FormData();
    const hourValue = stateField("hour_value");
    const dynamicEntryType = `hour_${hourValue}_entry_type`;
    let part = stateField("subject_part");

    if (stateField("entry_type") == "elective") part = "elective";
    form.append("course_uuid", stateField("course_uuid"));
    form.append("college_uuid", stateField("college_uuid"));
    form.append("semester", stateField("semester"));
    form.append("section", stateField("section"));
    form.append("college_year", stateField("college_year"));
    form.append("batch", stateField("batch"));
    form.append("subject", stateField("subject"));
    form.append("hour_value", stateField("hour_value"));
    form.append("day_value", stateField("day_value"));
    form.append("teacher", stateField("teacher"));
    form.append("subject_part", part);
    //form.append("entry_type", stateField("entry_type"));

    form.append(`hour_${hourValue}_entry_type`, stateField("entry_type"));
    form.append("attendance_date", attendaceDate);
    form.append("with_student_od", "1");
    form.append("att_approved", "1");
    axios
      .post(ServiceUrl.MOB.SEARCH_STUDENT_FOR_ATTENDANCE, form)
      .then((res) => {
        if (res["data"].status == "1") {
          let d = res["data"].data;
          if (res.data.marked_od) setMarkedOd(res.data.marked_od);
          if (res.data.time_slots) setTimeSlots(res.data.time_slots);

          const filteredStudents = res.data?.data.filter(
            (item) =>
              !item.admissiondate ||
              differenceBetweenTransferDates(
                item.admissiondate,
                attendaceDate,
                item,
                stateField("college_uuid"),
              ),
          );

          let m = groupByMultiple(filteredStudents, function (obj) {
            return [obj.course, lowerCase(obj.section)];
          });

          setDataList(filteredStudents);
          setDataView(m);
        } else {
          Toast.show({
            content: res["data"].message || "Error",
            position: "top",
          });
          context.setLoader(false);
        }
      });
  };

  const loadLongAbsenteeData = () => {
    context.setLoader(true);
    const form = new FormData();
    form.append("course_uuid", stateField("course_uuid"));
    form.append("college_uuid", stateField("college_uuid"));
    form.append("semester", stateField("semester"));
    form.append("section", stateField("section"));
    form.append("college_year", stateField("college_year"));
    form.append("batch", stateField("batch"));
    form.append("attendance_date", attendaceDate);

    axios.post(ServiceUrl.MOB.LIST_LONG_ABSENTEE, form).then((res) => {
      if (res["data"].status == "1") {
        let d = res["data"].data;

        setLongAbsentee(d);
      } else {
        Toast.show({
          content: res["data"].message || "Error",
          position: "top",
        });
        context.setLoader(false);
      }
    });
  };

  const checkMarkedAttendaceStatus = (item) => {
    let mlist = [...markedData, ...markedOd];
    let m = mlist.find(
      (obj) => obj.student_uuid == item.uuid && obj.course == item.course,
      //obj.day_value == item.day_value &&
      //obj.hour_value == item.hour_value &&
      //obj.semester == item.semester &&
      //obj.subject == item.subject &&
      //obj.teacher == item.teacher
    );
    return m;
  };

  const checkLongAbsentee = (uuid) => {
    let x = longAbsentee.findIndex((obj) => obj.student_uuid == uuid);
    return x > -1 ? true : false;
  };

  /*   const mergeData = () => {
    context.setLoader(true);
    let d = dataList;
    let x = [];
    d.map((item, i) => {
      let m = checkMarkedAttendaceStatus(item);
      let la = checkLongAbsentee(item.uuid);
      x.push({
        id: m?.id || "",
        course: item.course,
        registerno: item.registerno,
        admissionno: item.admissionno,
        student_name: item.student_name,
        section: lowerCase(item.section),
        batch: item.batch,
        semester: item.semester,
        day_value: m?.day_value || "",
        hour_value: m?.hour_value || "",
        leave_remarks: m?.leave_remarks || "",
        lesson_plan_topic_id: m?.lesson_plan_topic_id || "",
        student_uuid: item.uuid,
        leave_type: la ? "la" : m?.leave_type || "p",
        subject: stateField("subject"),
        teacher: stateField("teacher"),
      });
    });
    setMarkedStudents(x);
    context.setLoader(false);
  }; */

  const mergeData = () => {
    context.setLoader(true);
    let d = dataList;
    let x = [];
    const hourValue = stateField("hour_value");
    const dynamicSubject = `hour_${hourValue}_subject`;
    const dynamicTeacher = `hour_${hourValue}_teacher`;
    const dynamicTopic = `hour_${hourValue}_topic`;
    const dynamicRemark = `hour_${hourValue}_remark`;

    d.forEach((item) => {
      let m = checkMarkedAttendaceStatus(item);
      let la = checkLongAbsentee(item.uuid);

      x.push({
        id: m?.id || "",
        course_uuid: item.course_uuid,
        college_uuid: item.college_uuid,
        registerno: item.registerno,
        admissionno: item.admissionno,
        student_name: item.student_name,
        section: lowerCase(item.section),
        batch: item.batch,
        semester: item.semester,
        day_value: m?.day_value || "",
        hour_value: m?.hour_value || hourValue,
        [dynamicRemark]: m?.[`hour_${hourValue}_remark`] || "",
        [dynamicTopic]: m?.lesson_plan_topic_id || "",
        student_uuid: item.uuid,
        [`hour_${hourValue}_leave_type`]: la
          ? "la"
          : m?.[`hour_${hourValue}_leave_type`] || "p", // Corrected syntax for dynamic property
        [dynamicSubject]: stateField("subject"), // Corrected syntax for dynamic key
        [dynamicTeacher]: stateField("teacher"), // Corrected syntax for dynamic key
      });
    });

    setMarkedStudents(x);
    context.setLoader(false);
  };

  const confirmClick = () => {
    if (
      context.allowedAccess("mob_staff_workdone", "action_create") &&
      (!workDone || workDone == null)
    ) {
      Toast.show({ content: "Enter your work done" });
      workDoneRef.current.focus();
      return;
    }
    if (
      context.allowedAccess("mob_lesson_plan", "action_create") &&
      lessonPlanList &&
      lessonPlanList.length > 0 &&
      !selectedTopic
    ) {
      //Toast.show({ content: "Select your lesson plan" });
      Modal.alert({
        content: "Select your lesson plan",
        confirmText: "Ok",
      });
      return;
    }
    let abTotalcount = getAbsentCount();
    Dialog.confirm({
      //content: "Do you want to Save Attendance ?",
      content: (
        <>
          {getAbsentList()}
          {abTotalcount && abTotalcount > 0 && (
            <div className="fw-bold p-1 bg-red-50 border-bottom text-center text-danger">
              Total absentees: {getAbsentCount()} students.
            </div>
          )}
          Do you want to Save Attendance ?
        </>
      ),
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: () => saveAttendance(),
    });
  };

  const getStudentName = (uuid) => {
    let m = dataList.find((item) => item.uuid == uuid);
    return (m && m.student_name) || "";
  };

  const getAbsentCount = () => {
    const hourValue = stateField("hour_value");
    let d = markedStudents.filter(
      (item) =>
        item[`hour_${hourValue}_leave_type`] == "a" ||
        item[`hour_${hourValue}_leave_type`] == "la" ||
        item[`hour_${hourValue}_leave_type`] == "l",
    );
    return d.length;
  };

  const getAbsentList = () => {
    const hourValue = stateField("hour_value");
    let rv = [];
    markedStudents.map((item, i) => {
      if (
        item[`hour_${hourValue}_leave_type`] == "a" ||
        item[`hour_${hourValue}_leave_type`] == "la" ||
        item[`hour_${hourValue}_leave_type`] == "l"
      ) {
        rv.push(
          <tr className="border-bottom">
            <td>
              <span style={{ fontWeight: "500" }}>
                {item.registerno || item.admissionno}
              </span>
              <br />
              <span style={{ color: "#7a7979" }}>
                {getStudentName(item.student_uuid)}
              </span>
            </td>
            <td width="60" align="center">
              <span className="text-danger">
                {upperCase(item[`hour_${hourValue}_leave_type`])}
              </span>
            </td>
          </tr>,
        );
      }
    });

    return <table width="100%">{rv}</table>;
  };

  const absendClick = (item, ltype = "a") => {
    const hourValue = stateField("hour_value");
    let m = [...markedStudents];
    let index = m.findIndex((obj) => obj.student_uuid == item.uuid);

    if (index > -1) {
      if (checkStudentMarked(item) != ltype) {
        let lt = m[index][`hour_${hourValue}_leave_type`];
        if (lt == ltype) m[index][`hour_${hourValue}_leave_type`] = "";
        else m[index][`hour_${hourValue}_leave_type`] = ltype;
        setMarkedStudents(m);
      }
    }
  };

  const checkStudentMarked = (item) => {
    const hourValue = stateField("hour_value");
    const dynamicLeaveType = `hour_${hourValue}_leave_type`;

    let m = markedStudents;
    let index = m.findIndex((obj) => obj.student_uuid == item.uuid);
    return index > -1 && m[index][dynamicLeaveType];
  };

  const checkStudentMarkedRemark = (item) => {
    const hourValue = stateField("hour_value");
    const dynamicRemark = `hour_${hourValue}_remark`;
    let m = markedStudents;
    let index = m.findIndex((obj) => obj.student_uuid == item.uuid);
    return index > -1 && m[index][dynamicRemark];
  };

  const markedCount = (ltype) => {
    const hourValue = stateField("hour_value");
    let m = markedStudents.filter(
      (item) => item[`hour_${hourValue}_leave_type`] == ltype,
    );
    return m.length;
  };

  const saveAttendance = () => {
    context.setLoader(true);
    let clist = [];
    const form = new FormData();
    form.append("students", JSON.stringify(markedStudents));
    form.append("attendance_date", attendaceDate);
    form.append("day_value", stateField("day_value"));
    form.append("hour_value", stateField("hour_value"));
    form.append("teacher", stateField("teacher"));
    form.append("subject", stateField("subject"));
    form.append("course_uuid", stateField("course_uuid"));
    form.append("college_uuid", stateField("college_uuid"));
    form.append("college_year", stateField("college_year"));
    form.append("batch", stateField("batch"));
    form.append("semester", stateField("semester"));
    form.append("section", stateField("section"));
    // form.append("entry_type", stateField("entry_type"));
    const hourValue = stateField("hour_value");
    const dynamicEntryType = `hour_${hourValue}_entry_type`;
    form.append(`hour_${hourValue}_entry_type`, stateField("entry_type"));

    if (
      context.allowedAccess("mob_staff_workdone", "action_create") &&
      workDone
    )
      form.append("work_done", workDone);

    if (
      context.allowedAccess("mob_lesson_plan", "action_create") &&
      selectedTopic
    )
      form.append(`hour_topic`, selectedTopic);

    axios.post(ServiceUrl.MOB.SAVE_STUDENT_ATTENDANCE, form).then((res) => {
      if (res["data"].status == "1") {
        Toast.show({
          icon: "success",
          content: res["data"].message || "Success",
        });
        // auto back when user having update at anytime provision
        if (context.allowedAccess("mob_student_attendance", "action_update")) {
          navigate("/staff/app");
        } else {
          loadAllDatas();
          if (stateField("hour_value").length > 1) {
            navigate("/staff/app");
          }
        }
      } else {
        Toast.show({
          icon: "error",
          content: res["data"].message || "Error",
        });
      }
      setMarkedDataSource([]);
      context.setLoader(false);
    });
  };

  const swipeActionList = (item) => {
    if (checkLongAbsentee(item.uuid)) return [];

    if (
      !context.allowedAccess("mob_student_attendance", "action_update") &&
      markedData.length > 0
    )
      return [];

    let rv = [];

    if (allowOd)
      rv.push({
        key: "od",
        text: "OD",
        color: "primary",
        onClick: () => absendClick(item, "od"),
      });

    if (
      context.allowedAccess("mob_student_attendance_leave", "action_create")
    ) {
      rv.push({
        key: "l",
        text: "L",
        color: "light",
        onClick: () => absendClick(item, "l"),
      });
    }

    rv.push({
      key: "ab",
      text: "AB",
      color: "danger",
      onClick: () => absendClick(item),
    });

    if (checkStudentMarked(item) != "p")
      rv.push({
        key: "p",
        text: "P",
        color: "success",
        onClick: () => absendClick(item, "p"),
      });

    return rv;
  };

  const getExtraButton = (item) => {
    if (checkLongAbsentee(item.uuid)) return [];

    if (
      !context.allowedAccess("mob_student_attendance", "action_update") &&
      markedData.length > 0
    )
      return [];

    let sta = checkStudentMarked(item);

    let rv = [];
    rv.push(
      <Button
        size="md  me-2"
        variant={sta == "p" ? "success" : "light"}
        onClick={() => absendClick(item, "p")}
      >
        P
      </Button>,
    );
    rv.push(
      <Button
        size="md"
        variant={sta == "a" ? "danger" : "light"}
        onClick={() => absendClick(item)}
      >
        A
      </Button>,
    );
    return rv;
  };

  const handleDeleteClick = () => {
    Dialog.confirm({
      content: "Do you want to Delete ?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: () => {
        confirmDelete();
      },
    });
  };

  const confirmDelete = () => {
    context.setLoader(true);
    let d = markedData[0];
    let x = [];
    let m = groupByMultiple(dataList, function (obj) {
      return [obj.course, lowerCase(obj.section)];
    });

    m.map((item) =>
      x.push({ course_uuid: item[0].course_uuid, section: item[0].section }),
    );
    const form = new FormData();
    form.append("batch", d.batch);
    form.append("attendance_date", d.attendance_date);

    form.append("college_year", d.college_year);
    form.append("course_uuid", JSON.stringify(x));
    form.append("college_uuid", stateField("college_uuid"));
    form.append("day_value", stateField("day_value"));
    form.append("hour_value", stateField("hour_value"));
    form.append("semester", stateField("semester"));
    form.append("section", stateField("section"));
    form.append("teacher", stateField("teacher"));
    form.append("subject", stateField("subject"));
    //form.append("entry_type", stateField("entry_type"));
    const hourValue = stateField("hour_value");
    const dynamicEntryType = `hour_${hourValue}_entry_type`;
    form.append(`hour_${hourValue}_entry_type`, stateField("entry_type"));
    /*form.append("day_value", d.day_value);
    form.append("subject", d.subject);
    form.append("hour_value", d.hour_value);
    form.append("semester", d.semester);
    form.append("section", d.section);
    form.append("teacher", d.teacher);*/
    //
    axios.post(ServiceUrl.MOB.DELETE_TIMETABLE, form).then((res) => {
      if (res["data"].status == "1") {
        Toast.show({
          icon: "success",
          content: res["data"].message || "Success",
        });
        setMarkedStudents([]);
        loadMarkedAttendance();
        setMarkedData([]);
      } else {
        Toast.show({
          icon: "error",
          content: res["data"].message || "Error",
        });
      }
      context.setLoader(false);
    });
  };

  const listSelectedHourValues = () => {
    let h = stateField("hour_value");
    //if (h.length == 1) return "H" + h;

    //h = JSON.parse(h);

    return h;
  };

  useEffect(() => {
    if (timeSlots && timeSlots.length > 0) {
      checkTimeExist();
      const interval = setInterval(() => {
        checkTimeExist();
      }, 5000);
      return () => clearInterval(interval);
    } else {
      setAllowAttendance(true);
    }
    setAllowAttendance(true);
  }, [timeSlots]);

  const checkTimeExist = () => {
    let rv = true;
    let currentHour = stateField("hour_value");
    if (timeSlots && timeSlots.length > 0) {
      if (currentHour) {
        let s = timeSlots.find((item) => item.hour_value == currentHour);
        if (s) {
          var now = new Date();
          let start_time = false;
          let end_time = false;
          // to check attendance start time
          if (s && s.att_start_time) {
            start_time = new Date(
              momentDate(new Date(), "YYYY-MM-DD") + " " + s.att_start_time,
            );
          }
          if (s && s.att_end_time) {
            end_time = new Date(
              momentDate(new Date(), "YYYY-MM-DD") + " " + s.att_end_time,
            );
          }
          if (
            now.getTime() < start_time.getTime() ||
            now.getTime() > end_time.getTime()
          ) {
            rv = false;
          }
        }
      }
    }
    setAllowAttendance(rv);
  };

  const attendanceTimeMessage = () => {
    let rv = "";
    let currentHour = stateField("hour_value");
    if (timeSlots && timeSlots.length > 0) {
      if (currentHour) {
        let s = timeSlots.find((item) => item.hour_value == currentHour);
        if (s) {
          var now = new Date();
          let start_time = false;
          let end_time = false;
          // to check attendance start time
          if (s && s.att_start_time) {
            start_time = new Date(
              momentDate(new Date(), "YYYY-MM-DD") + " " + s.att_start_time,
            );
          }
          if (s && s.att_end_time) {
            end_time = new Date(
              momentDate(new Date(), "YYYY-MM-DD") + " " + s.att_end_time,
            );
          }
          if (now.getTime() < start_time.getTime()) {
            rv = `Attendance will begin at ${momentDate(
              start_time,
              "hh:mm A",
            )}`;
          }
          if (now.getTime() > end_time.getTime()) {
            rv = `Attendance closed at ${momentDate(end_time, "hh:mm A")}`;
          }
        }
      }
    }
    return rv;
  };

  const getSnoCount = (index) => {
    if (index == 0) return 0;
    let count = 0;
    dataView.map((item, i) => i < index && (count = count + item.length));

    return count;
  };

  const handleABClick = () => {
    Dialog.confirm({
      content: "Would you like to mark all the students as Absent?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: () => makrAllAsAbsent(),
    });
  };

  const makrAllAsAbsent = () => {
    dataView.map((items, i) => {
      items.map((item, j) => {
        if (!checkLongAbsentee(item.uuid)) {
          if (checkStudentMarked(item) != "a") absendClick(item, "a");
        }
      });
    });
  };

  const handlePClick = () => {
    Dialog.confirm({
      content: "Would you like to mark all the students as Present?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: () => makrAllAsPresent(),
    });
  };

  const makrAllAsPresent = () => {
    dataView.map((items, i) => {
      items.map((item, j) => {
        if (!checkLongAbsentee(item.uuid)) {
          if (checkStudentMarked(item) != "p") absendClick(item, "p");
        }
      });
    });
  };

  const markedcountWithoutOd = () => {
    const hourValue = stateField("hour_value");
    let count = 0;
    if (markedStudents && markedStudents.length > 0) {
      let s = markedStudents.filter(
        (item) =>
          item.id != "" &&
          upperCase(item[`hour_${hourValue}_leave_type`]) != "OD",
      );

      if (s && s.length > 0) count = s.length;
    }
    return count;
  };

  const getSaveButton = () => {
    let btn = (
      <Button
        variant="primary"
        className="w-100"
        onClick={(e) => confirmClick()}
      >
        Save
      </Button>
    );
    if (markedcountWithoutOd() > 0) {
      if (context.allowedAccess("mob_student_attendance", "action_update")) {
        return btn;
      } else return null;
    } else {
      return btn;
    }
  };

  return (
    <>
      <Header
        hideLogoText={true}
        backAction={true}
        title={
          <>
            Attendance Entry
            <div style={{ fontSize: "12px" }}>
              {momentDate(attendaceDate, "DD-MMM-YYYY")}
            </div>
          </>
        }
        rightActions={
          markedData.length > 0 ? (
            context.allowedAccess(
              "mob_delete_marked_attendance",
              "action_delete",
            ) ? (
              <li>
                <a
                  style={{ textDecoration: "underline" }}
                  className="text-primary"
                  onClick={(e) => handleDeleteClick()}
                >
                  Delete
                </a>
              </li>
            ) : (
              []
            )
          ) : (
            []
          )
        }
      />

      <div className="py-md-3">
        <section>
          <div className="container-sm ">
            <div className="py-1 text-center fw-bold fs-7">
              <b>{stateField("subject_code")}</b>
              {"-"}
              {stateField("subject_name")} - H-{listSelectedHourValues()}
            </div>
          </div>
          <div className="container-sm">
            {dataView.length < 1 && (
              <div className="bg-white">
                {SkeltonLoop(
                  20,
                  <div className="border-bottom p-3">
                    <Skeleton.Input
                      size="small"
                      loading={true}
                      active
                      block={true}
                    />
                  </div>,
                )}
              </div>
            )}

            {dataView.map((items, i) => {
              return (
                <>
                  <div
                    className="text-center py-2 text-primary"
                    data-aos="zoom-in"
                  >
                    <b className="fs-6">
                      {yearByBatch(items[0].batch)}-{items[0].degree_name}-
                      {items[0].course_short_name} (
                      {items[0].dept_type == "aided" ? "R" : "SF"}) -
                      {upperCase(items[0].section)}
                    </b>
                  </div>
                  {screenType == "swipe" && (
                    <SwipeScreen
                      items={items}
                      checkStudentMarked={(d) => checkStudentMarked(d)}
                      absendClick={(stu, lt) => absendClick(stu, lt)}
                      allowAttendance={allowAttendance}
                      markedData={markedData}
                      longAbsentee={longAbsentee}
                      checkLongAbsentee={checkLongAbsentee}
                    />
                  )}
                  {screenType == "button" && (
                    <ButtonScreen
                      sNo={getSnoCount(i)}
                      items={items}
                      checkStudentMarked={(d) => checkStudentMarked(d)}
                      absendClick={(stu, lt) => absendClick(stu, lt)}
                      allowAttendance={allowAttendance}
                      markedData={markedData}
                      longAbsentee={longAbsentee}
                      markedcountWithoutOd={markedcountWithoutOd}
                      checkLongAbsentee={checkLongAbsentee}
                      checkStudentMarkedRemark={checkStudentMarkedRemark}
                    />
                  )}
                </>
              );
            })}

            {context.allowedAccess("mob_staff_workdone", "action_create") && (
              <div className="mt-2">
                <Form.Control
                  as="textarea"
                  name="work_done_text"
                  className="fw-bold"
                  rows="4"
                  placeholder="Enter your work done here.. (Topics Discussed)"
                  ref={workDoneRef}
                  defaultValue={workDone}
                  onChange={(e) => setWorkDone(e.target.value)}
                />
              </div>
            )}
            {context.allowedAccess("mob_lesson_plan", "action_create") && (
              <div className="mt-2">
                {/*   <LessonPlanSelector
                  dataParams={searchParams}
                  dataSource={selectedLessonPlan}
                  onSuccess={(d) => {
                    setSelectedLessonPlan(d);
                    Modal.clear();
                  }}
                /> */}
                {lessonPlanList && lessonPlanList.length > 0 && (
                  <Select
                    showSearch
                    value={selectedTopic}
                    placeholder="Select Lesson Plan"
                    onChange={(value) => setSelectedTopic(value)} // Select only topic_id
                    style={{ width: "100%" }}
                    required
                    optionFilterProp="children" // This tells Select to filter based on option text
                  >
                    {lessonPlanList.map((item) => (
                      <Option key={item.topic_id} value={item.topic_id}>
                        {`${item.unit_title} > ${item.topic_name}`}
                      </Option>
                    ))}
                  </Select>
                )}
              </div>
            )}
          </div>
        </section>
      </div>
      <div className="py-4"></div>
      <div className="footer-nav-area pt-2 px-3">
        <div className="suha-footer-nav " style={{ height: "42px" }}>
          <div className="row">
            <div className="col-4">
              {allowAttendance ? (
                <>{getSaveButton()}</>
              ) : (
                <>{attendanceTimeMessage()}</>
              )}
            </div>
            <div className="col-8 text-end">
              <Button
                size="sm"
                variant="light"
                style={{ fontSize: "12px" }}
                onClick={(e) => handleABClick()}
              >
                <span className="border-bottom text-danger">AB</span> :
                <span className="text-danger">{markedCount("a")}</span>
              </Button>
              {context.allowedAccess(
                "mob_student_attendance_leave",
                "action_create",
              ) && (
                <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                  <span className="border-bottom text-dark">L</span> :
                  <span className="text-dark">{markedCount("l")}</span>
                </Button>
              )}
              <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                <span className="border-bottom text-primary">OD</span>:
                <span className="text-primary">{markedCount("od")}</span>
              </Button>
              <Button size="sm" variant="light" style={{ fontSize: "12px" }}>
                <span className="border-bottom text-danger">LA</span>:
                <span className="text-danger ">{markedCount("la")}</span>
              </Button>
              <Button
                size="sm"
                variant="light"
                style={{ fontSize: "12px" }}
                onClick={(e) => handlePClick()}
              >
                <span className="border-bottom text-success">P</span>:
                <span className="text-success ">{markedCount("p")}</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AttendanceEntry;
